import React from 'react';
import { getProgram, posterUrl } from '../../data/loadData';

const TheaterFestival = () => {
    const theaterData = getProgram(2025).events || [];

    const getGenreBadgeColor = (genre) => {
        const colors = {
            'Komedi': 'success',
            'Drama': 'primary',
            'Konferans': 'info',
            'Canlı Heykel': 'warning',
            'Müzikal': 'danger',
            'Trajikomedi': 'secondary',
            'Çocuk Oyunu': 'success',
            'Klasik': 'dark',
            'Trajedi': 'danger',
            'Aile': 'info'
        };
        return colors[genre] || 'success';
    };

    function formatTextWithBreaks(text) {
        return String(text || '').split('\n').map((line, index, array) => (
            <React.Fragment key={index}>
                {line}
                {index < array.length - 1 && <br />}
            </React.Fragment>
        ));
    }

    const sortedEvents = [...theaterData].sort((a, b) => {
        if (!a.tarih || !String(a.tarih).trim()) return 1;
        if (!b.tarih || !String(b.tarih).trim()) return -1;
        const dayA = String(a.tarih).split(' ')[0].padStart(2, '0');
        const dayB = String(b.tarih).split(' ')[0].padStart(2, '0');
        const hourA = a.saat || '99:99';
        const hourB = b.saat || '99:99';
        return `${dayA}-${hourA}`.localeCompare(`${dayB}-${hourB}`);
    });

    return (
        <div className="container-fluid" id="festival-programi">
            <div className="row">
                <div className="col-12">
                    <div className="text-center mb-4">
                        <div className="card shadow-lg border-0 rounded-4">
                            <div className="card-body">
                                <h2 className="text-center mb-4 fw-bold text-primary"> 17. ETHOS ANKARA ULUSLARARASI TİYATRO FESTİVALİ</h2>
                                <div className="row mb-4">
                                    <div className="col-md-6">
                                        <h5 className="fw-semibold text-secondary">Yurtdışı Katılımlar</h5>
                                        <p className="mb-0">
                                            <strong> Almanya, Özbekistan, Kazakistan, Gürcistan, Makedonya, İran’dan
                                                toplamda
                                                10 yurtdışı Tiyatro Topluluğu</strong>.
                                        </p>
                                    </div>
                                    <div className="col-md-6">
                                        <h5 className="fw-semibold text-secondary">Türkiye Katılımları</h5>
                                        <p className="mb-0">
                                            <strong>10</strong> Ankara, <strong>2</strong> Antalya, <strong>2</strong> İstanbul, <strong>3</strong> İzmir, <strong>1</strong> Çanakkale, <strong>1</strong>
                                            Trabzon, <strong>1</strong> Kırşehir, <strong>1</strong> Sinop
                                            ve <strong>1</strong> Eskişehir olmak üzere toplam:
                                            <strong>10</strong> Ankara ve <strong>12</strong> Şehir Dışı Topluluk.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {sortedEvents.map((item, index) => (
                            <div key={index} className="col-lg-6 col-xl-4 mb-4">
                                <div className="card h-100 shadow-lg border-0 overflow-hidden"
                                     style={{transition: 'transform 0.3s ease, box-shadow 0.3s ease'}}
                                     onMouseEnter={(e) => {
                                         e.currentTarget.style.transform = 'translateY(-8px)';
                                         e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
                                     }}
                                     onMouseLeave={(e) => {
                                         e.currentTarget.style.transform = 'translateY(0)';
                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                                     }}>
                                    <div className="position-relative">
                                        <img
                                            src={posterUrl(2025, item.afis, 'images/2025/0.jpg')}
                                            alt={item.oyun}
                                            className="w-100"
                                            style={{transition: 'transform 0.3s ease'}}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                        />
                                        <div className=" bottom-0 start-0 w-100 p-3"
                                             style={{
                                                 background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                                                 color: 'white'
                                             }}>
                                            <div className="d-flex justify-content-between align-items-end">
                                                <div>
                                                    <div className="small mb-1 opacity-75">{item.tarih}</div>
                                                    <div className="fw-bold">{item.saat || ''}</div>
                                                </div>
                                                <span className={`badge bg-${getGenreBadgeColor(item.tur)} px-3 py-2`}
                                                      style={{fontSize: '0.85rem'}}>
                                                    {item.tur}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-body d-flex flex-column p-4">
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                            <h5 className="card-title fw-bold mb-0"
                                                style={{
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',
                                                    fontSize: '1.3rem',
                                                    lineHeight: '1.4',
                                                    flex: 1
                                                }}>
                                                {item.oyun}
                                            </h5>
                                            <span className={`badge bg-${getGenreBadgeColor(item.yas)} ms-2`}
                                                  style={{fontSize: '0.85rem', whiteSpace: 'nowrap'}}>
                                                {item.yas}
                                            </span>
                                        </div>

                                        <div className="mb-3 pb-3 border-bottom">
                                            <div className="d-flex align-items-center text-muted small mb-2">
                                                <span className="fw-semibold">{formatTextWithBreaks(item.topluluk)}</span>
                                            </div>
                                            <div className="d-flex align-items-center text-muted small">
                                                <span>{formatTextWithBreaks(item.salon)}</span>
                                            </div>
                                        </div>

                                        {item.aciklama && (
                                            <div className="mb-3 flex-grow-1">
                                                <div className="small text-secondary" style={{ lineHeight: '1.5' }}>
                                                    {formatTextWithBreaks(item.aciklama)}
                                                </div>
                                            </div>
                                        )}

                                        {item.bilet ? (
                                            <a
                                                href={item.bilet}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-primary w-100 fw-bold py-2 mt-auto"
                                                style={{
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    border: 'none',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1.02)';
                                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                                                }}>
                                                Bilet Al
                                            </a>
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>

                                    <div className="card-footer bg-light text-muted small">
                                        {item.sehir}{item.sehir && item.ulke ? ', ' : ''}{item.ulke}
                                        {item.perde ? ` • ${item.perde} Perde` : ''}
                                        {item.sure ? ` • ${item.sure}` : ''}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="row mt-5">
                        <div className="col-12">
                            <div className="card shadow">
                                <div className="card-header bg-info text-white">
                                    <h5 className="mb-0">📊 Festival İstatistikleri</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row text-center">
                                        <div className="col-md-3 mb-3">
                                            <div className="h2 text-primary">
                                                {[...new Set(theaterData.map(item => item.ulke))].length}
                                            </div>
                                            <div className="text-muted">Ülke</div>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <div className="h2 text-success">
                                                {[...new Set(theaterData.map(item => item.sehir))].length}
                                            </div>
                                            <div className="text-muted">Şehir</div>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <div className="h2 text-warning">
                                                {[...new Set(theaterData.map(item => item.tur))].length}
                                            </div>
                                            <div className="text-muted">Farklı Tür</div>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <div className="h2 text-danger">{theaterData.length}</div>
                                            <div className="text-muted">Toplam Etkinlik</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TheaterFestival;
